<template>
  <div>
    <vs-popup :title="$t(popupTitle)" :active.sync="showModal">
      <form id="contract-form">
        <div class="vx-row mb-2">
          <div class="vx-col w-full">
            <vs-input
              class="inputx mb-2"
              :label="$t('ContractName')"
              v-model="model.title"
              name="contractName"
              v-validate="{ required: true }"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('contractName')"
              >{{ errors.first("contractName") }}</span
            >
          </div>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col w-full">
            <label class="vs-select--label">{{ $t("ContractType") }}</label>
            <v-select
              label="name"
              name="cType"
              :options="contractType"
              v-model="model.salesType"
              v-validate="{ required: true }"
              :reduce="(x) => x.id"
              dir="rtl"
              class="mb-2"
            >
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('cType')">{{
              errors.first("cType")
            }}</span>
          </div>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col w-full">
            <vs-input
              class="inputx mb-2"
              :label="$t('ValueAddedTax')"
              v-model="model.valueAddedTax"
              name="tax"
              v-validate="{ regex: '^([0-9]+)$' }"
            />
            <span class="text-danger text-sm" v-show="errors.has('tax')">{{
              errors.first("tax")
            }}</span>
          </div>
        </div>
        <div class="mb-2 flex flex-wrap gap-4">
          <div class="flex-grow">
            <label class="vs-select--label datepicker-lb">{{
              $t("StartDate")
            }}</label>
            <date-picker
              v-model="model.startClock"
              format="jYYYY-jMM-jDD"
              display-format="jYYYY-jMM-jDD"
              class="date-picker mb-2"
              :label="$t('StartDate')"
              name="startDate"
              v-validate="{ required: true }"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('startDate')"
              >{{ errors.first("startDate") }}</span
            >
          </div>
          <div class="flex-grow">
            <label class="vs-select--label datepicker-lb">{{
              $t("EndDate")
            }}</label>
            <date-picker
              v-model="model.expireClock"
              format="jYYYY-jMM-jDD"
              display-format="jYYYY-jMM-jDD"
              class="date-picker mb-2"
              :label="$t('EndDate')"
              name="endDate"
              v-validate="{ required: true }"
            />
            <span class="text-danger text-sm" v-show="errors.has('endDate')">{{
              errors.first("endDate")
            }}</span>
          </div>
        </div>
        <div class="flex flex-col mt-4">
          <label class="vs-select--label">{{ $t("ToleranceType") }}</label>
          <v-select
            label="title"
            name="toleranceType"
            :options="toleranceTypes"
            v-model="model.toleranceType"
            v-validate="{
              required:
                model.allowedReduction || model.allowedIncrease ? true : false,
            }"
            :reduce="(x) => x.id"
            class="w-full"
            dir="rtl"
          >
          </v-select>
          <span
            class="text-danger text-sm"
            v-show="errors.has('toleranceType')"
            >{{ errors.first("toleranceType") }}</span
          >
          <div class="flex flex-wrap gap-x-4 my-4">
            <div class="flex-grow">
              <vs-input
                class="inputx"
                v-model="model.allowedReduction"
                name="reductionRate"
                :label="$t('AllowedReduction')"
                v-validate="{ required: model.toleranceType ? true : false }"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('reductionRate')"
                >{{ errors.first("reductionRate") }}</span
              >
            </div>
            <div class="flex-grow">
              <vs-input
                class="inputx"
                v-model="model.allowedIncrease"
                name="increaseRate"
                :label="$t('AllowedIncrease')"
                v-validate="{ required: model.toleranceType ? true : false }"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('increaseRate')"
                >{{ errors.first("increaseRate") }}</span
              >
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-checkbox v-model="model.isActive">{{
              $t("Active")
            }}</vs-checkbox>
          </div>
        </div>
        <div class="vx-row mb-2 justify-content-md-center">
          <my-upload
            field="img"
            @crop-success="cropSuccess"
            v-model="showUploader"
            :width="100"
            :height="100"
            langType="fa"
            :noCircle="true"
            img-format="jpg"
          ></my-upload>
          <div class="vx-col md:w-1/4 w-1/2">
            <div
              class="flex h-24 bg-grey-light rounded-t-lg justify-center items-center"
            >
              <img
                v-bind:src="model.logoImage"
                v-if="model.logoImage"
                class="w-24 h-24"
              />
            </div>
            <a class="uploadImg img-box" @click.prevent="toggleShow">
              <i class="material-icons notranslate"> cloud_upload </i>
              {{ $t("LogoImage") }}
            </a>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button
              type="filled"
              class="float-right"
              @click.prevent="submitForm()"
              :disabled="disabled"
              >{{ $t("Save") }}</vs-button
            >
          </div>
        </div>
      </form>
    </vs-popup>
  </div>
</template>
<style lang="scss">
.removeIco {
  float: left !important;
  top: 10px !important;
  left: 10px !important;
}
</style>
<script>
import { mapActions } from "vuex";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import vSelect from "vue-select";
import { Validator } from "vee-validate";
import myUpload from "vue-image-crop-upload";

const dict = {
  custom: {
    contractName: {
      required: "لطفا نام قرارداد را وارد نمایید.",
    },
    cType: {
      required: "لطفا نوع قرارداد را انتخاب نمایید.",
    },
    startDate: {
      required: "لطفا تاریخ شروع قرارداد را انتخاب نمایید.",
    },
    endDate: {
      required: "لطفا تاریخ پایان قرارداد را انتخاب نمایید.",
    },
    tax: {
      regex: "مقدار وارد شده مجاز نمی باشد",
    },
    reductionRate: {
      required: "لطفا مقدار کاهش مجاز را وارد نمایید.",
    },
    increaseRate: {
      required: "لطفا مقدار افزایش مجاز را وارد نمایید.",
    },
    toleranceType: {
      required: "لطفا نوع تغییرات را انتخاب نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "saleManagement_Contract_ModifyPopup",

  props: {
    show: { default: false },
    model: {
      default: {},
    },
    keywords: {},
  },
  data() {
    return {
      popupTitle: "",
      contractType: [
        { name: "فروش داخلی", id: 0 },
        { name: "فروش وبسایت", id: 1 },
        { name: "فروش نمایندگان", id: 2 },
        { name: "فروش سازمانی", id: 3 },
        { name: "فروش مستقیم", id: 4 },
      ],
      toleranceTypes: [
        { id: 1, title: "درصدی" },
        { id: 2, title: "مقداری" },
      ],
      disabled: false,
      showUploader: false,
    };
  },

  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      createContract: "sale/createContract",
      updateContract: "sale/updateContract",
    }),
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.disabled = true;
          this.createContract(this.model).then(() => {
            setTimeout(() => {
              this.$emit("finish");
              this.model = {};
              this.$validator.reset();
            }, 2000);
          });
          this.disabled = false;
        } else {
          // form have errors
        }
      });
    },
    cropSuccess(imgDataUrl) {
      this.model.logoImage = imgDataUrl;
    },
    toggleShow() {
      this.showUploader = !this.showUploader;
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        this.popupTitle = "CreateNewContract";
      }
      this.$validator.reset();
    },
  },
  components: {
    datePicker: VuePersianDatetimePicker,
    "v-select": vSelect,
    "my-upload": myUpload,
  },
};
</script>
